import Image from "next/image";
import Link from "next/link";
import logo from "@/public/ventura-logo.png";
import { useRouter } from "next/router";

const Logo = () => {
  const router = useRouter();

  return (
    <Link href="/" className="relative z-20 select-none transition lg:mr-auto lg:inline-block lg:shrink-0 xl:w-1/5" aria-label="Home">
      <div className="w-[200px]">
        <Image
          src={logo}
          alt="Ventura Web Design and Marketing"
          width={840}
          height={197}
          quality={100}
          className={router.pathname === "/shopify" ? "brightness-150 -hue-rotate-[140deg] saturate-50" : ""}
          sizes="(max-width: 640px) 30vw, 200px"
        />
      </div>
    </Link>
  );
};

export default Logo;
